import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { URL } from "../../Redux/common/url";

function CmimgSeller({ url, altkey }) {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div>
      <img
        src={url}
        alt={altkey}
        className={`blur-image ${isLoaded ? "hide" : ""}`}
        style={{
          width: "100%",
          filter: "blur(20px)",
          transition: "opacity 0.3s ease-in-out",
          opacity: isLoaded ? 0 : 1,
        }}
      />
      <LazyLoadImage
        alt={altkey}
        // width={imageWidth}
        // height={imageHeight}
        delayTime={300}
        onLoad={() => setIsLoaded(true)}
        style={{
          // Hide until loaded
          width: "100%",
          transition: "opacity 0.1s ease-in-out",
          opacity: isLoaded ? 1 : 0,
        }}
        src={url} // use normal <img> attributes as props
      />
    </div>
  );
}

export default CmimgSeller;
